import { FC, ReactNode } from 'react';
import { ConnatixPlacementProvider } from './connatixOutstream';
import { PrimisPlacementProvider } from './primisOutstream';

export const VideoPlacementProviders: FC<{ children: ReactNode }> = ({ children }) => (
  <PrimisPlacementProvider>
    <ConnatixPlacementProvider>{children}</ConnatixPlacementProvider>
  </PrimisPlacementProvider>
);
